import { useState } from "react";

import { Form } from "@ui/components/Form";
import { useTranslations } from "@ui/providers/useTranslations";

import { Card } from "@jti/core-components/components/Card";

import { useLoyaltyReferralCode } from "../../hooks/useLoyaltyReferralCode";
import type { LoyaltyReferralCodeProps } from "../../types";
import { LoyaltyReferralCodeForm } from "../LoyaltyReferralCodeForm/LoyaltyReferralCodeForm";

import styles from "./LoyaltyReferralCode.module.scss";

export const LoyaltyReferralCode = ({ onCodeApplied, source }: LoyaltyReferralCodeProps) => {
  const [collapsed, setCollapsed] = useState(true);
  const { __ } = useTranslations();

  const { hideCard, verifyCode, updateReferralCode, onSubmit, codeCustomErrorMessage, form, isSuccess } =
    useLoyaltyReferralCode({
      onCodeApplied,
      verifyErrorMessage: __("cart.loyalty.referral.form.validation.verifyCode"),
      whenHasParentCode: () => setCollapsed(false),
      source,
    });

  if (hideCard) {
    return null;
  }
  const disabled = !form.formState.isValid || updateReferralCode.isLoading || verifyCode.isLoading || isSuccess;

  return (
    <Card
      variant="level-1-club"
      data-testid="loyaltyReferralCode"
      isCollapsible
      defaultCollapsed={collapsed}
      title={__("cart.loyalty.referral.title")}
      description={__("cart.loyalty.referral.subtitle")}
    >
      <Form form={form} onSubmit={onSubmit}>
        <LoyaltyReferralCodeForm
          isSuccess={isSuccess}
          disabled={disabled}
          error={codeCustomErrorMessage ?? null}
          requiredText={__("cart.loyalty.referral.form.validation.required")}
          label={__("cart.loyalty.referral.form.label")}
          placeholder={__("cart.loyalty.referral.form.placeholder")}
          helperText={__("cart.loyalty.referral.form.helperText")}
          successText={__("cart.loyalty.referral.form.successText")}
          btnLabel={__("cart.loyalty.referral.form.submit")}
          contentWrapperClassname={styles.formWrapper}
        />
      </Form>
    </Card>
  );
};
